const baseUrl = 'http://192.168.1.18:3001'
// const baseUrl = ''



export const fetchProducts = async () => {
    try {
        const res = await fetch(baseUrl + "/product/query", {
            method: "POST",
            headers: { "Content-Type": "application/json" }
        })
        const data = await res.json()
        if (data.result === "SUCCESS") {
            return data.message
        } else {
            console.log(data)
            return null;
        }
    } catch (error) {
        console.log(error)
    }
}

export const fetchAddress = async () => {
    try {
        const res = await fetch(baseUrl + "/maxmind", {
            method: "POST",
            headers: { "Content-Type": "application/json" }
        });
        const data = await res.json()
        if (data) {
            return data
        } else {
            console.log(data)
            return null;
        }
    } catch (error) {
        console.log(error)
    }
}

export const proceedCheckOut = async (paramsString) => {
    try {
        let res = await fetch(baseUrl + "/leads/import", {
            method: "POST",
            body: JSON.stringify({ url: `${paramsString}` }),
            headers: { "Content-Type": "application/json" }
        });
        let data = await res.json();
        if (data.result === "SUCCESS") {
            return data.message
        } else {
            console.log(data)
            return null;
        }
    } catch (error) {
        console.log(error)
    }
}